import React from 'react'
import Header from '../Components/Header'
import Footer from '../Components/Footer'
import Privacy from '../Pages/Privacy'

function PrivacyLayout() {
  return (
    <>
    <Header />
    <Privacy />
    <Footer />
    </>
  )
}

export default PrivacyLayout